class LumusIntentionGuide extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /** Filters the grid on this page instead of reloading, when there is one. */
  #onClick(event) {
    const card = event.target instanceof Element ? event.target.closest('[data-intention]') : null;
    const grid = document.querySelector('lumus-collection-grid');
    if (!card || !grid || typeof grid.select !== 'function') return;

    const intention = card.getAttribute('data-intention');
    if (!grid.querySelector(`[data-intention="${CSS.escape(intention)}"]`)) return;

    event.preventDefault();
    grid.select(intention);
    grid.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('lumus-intention-guide')) customElements.define('lumus-intention-guide', LumusIntentionGuide);
